import React from 'react';
import './Counter.css';

interface CounterProps {
  label: string;
  value: number;
  min?: number;
  max?: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

const Counter: React.FC<CounterProps> = ({
  label,
  value,
  min = 0,
  max = 99,
  onIncrement,
  onDecrement,
}) => {
  return (
    <div className="counter-wrapper">
      <label className="counter-label">{label}</label>
      <div className="counter-controls">
        <button
          type="button"
          className="counter-btn"
          onClick={onDecrement}
          disabled={value <= min}
        >
          -
        </button>
        <span className="counter-value">{value}</span>
        <button
          type="button"
          className="counter-btn"
          onClick={onIncrement}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default Counter;

